
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiTwowayAcuatorGeneralClosedRight as ObiTwowayAcuatorGeneralClosedRightElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-twoway-acuator-general-closed-right.js';
 
 
 

 
 export const ObiTwowayAcuatorGeneralClosedRight = createComponent({
   react: React,
   tagName: 'obi-twoway-acuator-general-closed-right',
   elementClass: ObiTwowayAcuatorGeneralClosedRightElement,
   events: {
     
   }
  });
 
 